import {isWebview} from '@/utils/helper';
import globalDomains from '@/utils/global-domains';
import throwToast from '@/utils/ui/toast';
import checkDevice from './checkDevice';
import {bridgeHandler, deepLinkHandler} from './bridgeHandler';

export const shareLink = (url) => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        if (!isWebview) {
          throwToast('미션 이벤트의 URL이 복사되었어요');
        } else {
          bridgeHandler('THROW_TOAST', {
            msg: '미션 이벤트의 URL이 복사되었어요',
          });
        }
      })
      .catch((err) => {
        if (!isWebview) {
          throwToast('URL 복사 실패');
        } else {
          bridgeHandler('THROW_TOAST', {msg: 'URL 복사 실패'});
        }
      });
  }
};

export const navigateToDetail = () => {
  if (checkDevice() === 'Web') {
    window.open(`${globalDomains.BJ_AFREECATV}/soopi/post/155292059`);
  } else {
    deepLinkHandler('NAVIGATE_BROWSER', {
      url: `${globalDomains.BJ_AFREECATV}/soopi/post/155292059`,
    });
  }
};
